import { Modal } from "antd";
import { ModalHeader, BulkUploadServiceTemplateUi } from "ui";

const BulkUploadServiceTemplateModal = ({
  showModal,
  handleShowModal,
  isUploadLoding = false,
  handleUploadClick,
}: {
  showModal: boolean;
  handleShowModal: (showModal: boolean) => void;
  isUploadLoding?: boolean;
  handleUploadClick: (e: any) => void;
}) => {
  return (
    <Modal
      style={{
        padding: 0,
        borderRadius: "0.5rem",
        overflow: "hidden",
      }}
      bodyStyle={{ padding: 0 }}
      footer={null}
      open={showModal}
      zIndex={1100}
      width={420}
      onCancel={() => handleShowModal(false)}
    >
      <ModalHeader
        title={"Bulk Upload"}
        onClose={() => handleShowModal(false)}
      />
      <BulkUploadServiceTemplateUi
        onUploadClick={handleUploadClick}
        loading={isUploadLoding}
      />
    </Modal>
  );
};

export default BulkUploadServiceTemplateModal;
